/**
 * MenuItemPicker — Overlay for menu item cards on desktop.
 * Same pattern as HotelsPicker/ProductPicker.
 */
import { MenuItemCard } from './MenuItemCard.js';

export class MenuItemPicker {
  constructor(options = {}) {
    this.primaryColor = options.primaryColor || '#2563eb';
    this.onItemSelect = options.onItemSelect || (() => {});
    this.onAddDisabled = options.onAddDisabled || (() => false);
    this.onClose = options.onClose || (() => {});

    this.element = null;
    this._cards = [];
  }

  show(items, title) {
    this.hide();
    if (!items || items.length === 0) return null;

    const wrapper = document.createElement('div');
    wrapper.className = 'picker-relative';

    const picker = document.createElement('div');
    picker.className = 'ttp-product-picker';

    const header = document.createElement('div');
    header.className = 'ttp-picker-header';
    header.innerHTML = `
      <span class="ttp-picker-title">${title || 'Menu'}</span>
      <button class="ttp-picker-close" aria-label="Close">\u00D7</button>
    `;
    header.querySelector('.ttp-picker-close').addEventListener('click', () => {
      this.hide();
      this.onClose();
    });
    picker.appendChild(header);

    const productsEl = document.createElement('div');
    productsEl.className = 'ttp-products-horizontal';

    this._cards = [];
    items.forEach(item => {
      const card = new MenuItemCard(item, {
        primaryColor: this.primaryColor,
        onSelect: (itemData) => {
          if (this.onAddDisabled()) return;
          this.onItemSelect(card.element, itemData);
        },
      });
      productsEl.appendChild(card.element);
      this._cards.push(card);
    });

    picker.appendChild(productsEl);
    wrapper.appendChild(picker);
    this.element = wrapper;
    return wrapper;
  }

  hide() {
    if (this.element && this.element.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }
    this.element = null;
    this._cards = [];
  }

  destroy() {
    this.hide();
  }
}
